var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
export const Margin = (_a) => {
    var { children, top, right, bottom, left } = _a, props = __rest(_a, ["children", "top", "right", "bottom", "left"]);
    const marginTop = top ? Number(top) + 'px' : undefined;
    const marginRight = right ? Number(right) + 'px' : undefined;
    const marginBottom = bottom ? Number(bottom) + 'px' : undefined;
    const marginLeft = left ? Number(left) + 'px' : undefined;
    const style = {
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
    };
    return React.cloneElement(children, Object.assign({ style }, props));
};
//# sourceMappingURL=margin.js.map